module.exports = __webpack_public_path__ + "img/ico_seccion.c46384dc.svg";